<template>
	<slot />
	<div class="text-center md:py-6 mb-4 md:mb-10">
		<slot name="cta" />
	</div>
</template>
